export default "__VITE_ASSET__DUb5RSv4__"